import React from 'react';

import { ProgressBarWrapper } from './style';

interface IProgressBar {
  progress: number;
  hasTitle: boolean;
  message?: string;
}

const ProgressBar: React.FC<IProgressBar> = ({ progress, hasTitle, message }) => {
  return (
    <ProgressBarWrapper>
      {hasTitle ? (
        <div className="legend-progress">
          <h5>já assistido</h5>
          <span>{progress?.toString().replace('.', ',')}% {message ? ` ${message}` : ''}</span>
        </div>
      ) : (
        <></>
      )}

      <div className="progress-bar">
        <div style={{ width: `${progress}%` }}></div>
      </div>
    </ProgressBarWrapper>
  );
};

export default ProgressBar;
